import { cn } from "@/lib/utils";
import { SpinnerRing } from "./SpinnerRing";

interface SpinnerProps {
  className?: string;
  size?: "sm" | "md" | "lg";
}

export function Spinner({ className, size = "md" }: SpinnerProps) {
  const sizeClasses = {
    sm: "size-4",
    md: "size-8",
    lg: "size-12",
  };
  return (
    <div className="flex items-center justify-center w-full py-8">
      <SpinnerRing
        className={cn(sizeClasses[size], className)}
        strokeWidth={size === "sm" ? 2.5 : 2}
      />
    </div>
  );
}
